import type {
  LeisureCategoryResponse,
  LeisureSearchHeaderResponse,
  LeisureSearchCountResponse,
  SearchListResponse,
  LeisureSearchRequestBody,
} from '@weberus/shared-types';

import { fetcher } from '@/app/_shared/utils/fetcher';

/**
 * 레저 카테고리 조회
 */
export const fetchCategory = async (headers?: Headers) => {
  return fetcher<LeisureCategoryResponse>({ method: 'GET', url: '/list/leisure/category', headers });
};

/**
 * 레저 Search 조회
 */
export const fetchLeisureSearch = async (args: LeisureSearchRequestBody) => {
  return fetcher<SearchListResponse, LeisureSearchRequestBody>({
    url: '/list/leisure/search',
    method: 'POST',
    data: args,
  });
};

/**
 * 레저 Search Header 조회
 */
export const fetchLeisureSearchHeader = async (args: LeisureSearchRequestBody, headers?: Headers) => {
  return fetcher<LeisureSearchHeaderResponse, LeisureSearchRequestBody>({
    method: 'POST',
    url: `/list/leisure/search/header`,
    data: args,
    headers, // SSR 시에는 headers를 주입해야함
  });
};

/**
 * 레저 개수 조회
 */
export const fetchLeisureSearchCount = async (args: LeisureSearchRequestBody) => {
  return fetcher<LeisureSearchCountResponse, LeisureSearchRequestBody>({
    method: 'POST',
    url: `/list/leisure/search/count`,
    data: args,
  });
};
